(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonial"] && !Shopify.designMode) return;
  try {
    
 $('.test-list').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  infinite: true,
  centerMode: false,
  dots: false,
  autoplay: true,
  autoplaySpeed: 3000, 
  pauseOnHover: false,
  pauseOnFocus: false
});

// Restart autoplay when arrows are clicked
$('.test-list').on('afterChange', function(event, slick, currentSlide){
  slick.slickPlay();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video_testimonial"] && !Shopify.designMode) return;
  try {
    
  $('.video-list').slick({
    slidesToShow: 3,
     slidesToScroll: 1,
     arrows: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
  $('.play-btn').click(function() {
    $('.video-bg').removeClass('hidden');
    $('.testimonial-video #video').each(function(){
      $(this).get(0).pause();
    });
    $(this).parent('.video-bg').addClass('hidden');
    $(this).parents('.testimonial-video').find('video').trigger('play'); 
  });

  } catch(e) { console.error(e); }
})();
})();
